export function resolveSsoErrorMessage(
  code: string | null,
  detail: string | null,
  flow: 'login' | 'register',
): string {
  if (!code) return '';

  const fallback =
    flow === 'register'
      ? 'Google sign-up could not be completed'
      : 'Google sign-in could not be completed';

  const messages: Record<string, string> =
    flow === 'register'
      ? {
          access_denied: 'Google sign-up was cancelled',
          account_not_found: 'This Google email already has an account. Sign in instead.',
          email_exists: 'This Google email is already registered. Sign in instead.',
          invalid_state: 'Google sign-up expired — try again',
          oauth_error: 'Google OAuth configuration error — contact support or use the form below',
          profile_incomplete: 'Google did not share your email — allow email access and try again',
          sso_failed: 'Google sign-up failed. Try the form below or sign in if you already have an account.',
        }
      : {
          access_denied: 'Google sign-in was cancelled',
          account_not_found:
            'No account found for this Google email. Create an account first, or sign in with your work email and password.',
          email_exists: 'This Google email is already registered. Sign in with Google or your password.',
          invalid_state: 'Google sign-in expired — try again',
          oauth_error: 'Google OAuth configuration error — contact support or use email and password',
          profile_incomplete: 'Google did not share your email — allow email access and try again',
          sso_failed: 'Google sign-in failed. Use email and password, or create an account first.',
        };

  const base = messages[code] ?? fallback;
  if (detail && (code === 'oauth_error' || code === 'sso_failed' || code === 'profile_incomplete')) {
    return `${base} (${detail})`;
  }
  return base;
}
